var exports = {
  "z": "messageMeta__0EMCCc",
  "L": "messageText__DXKXHx",
};

module.exports = exports;
